<template>
    <div>
        <Breadcrumbs main="" :title="$t('lbl_EMPBE_MyMessage')" />
        <visitorPermission>
            <template v-slot:body>
                <div class="container-fluid">
                    <div class="email-wrap bookmark-wrap">
                        <div class="row">
                            <listingVue></listingVue>
                            <b-sidebar id="MyMessageRightpopup" class="customSidebar" title="" right bg-variant="white"
                                backdrop :shadow="true" :visible="currentRouteName != 'MyMessage'"
                                ref="MyMessageRightpopup">
                                <router-view></router-view>
                            </b-sidebar>

                        </div>
                    </div>
                </div>
            </template>
        </visitorPermission>
    </div>
</template>

<script>
import listingVue from './listing.vue';

export default {
    components: {
        listingVue
    },
    data() {
        return {

        }
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        }
    }
}

</script>